import React, { Component } from 'react';
import { objEmpty, stringToBool, getBrandFromProvider, validateBusinessId } from './helper.js';
import { Redirect } from 'react-router';
import {Link} from 'react-router-dom';
import { OrderInformation, SubNav } from './components.js'
import './order.css';
import * as CONSTS from './consts.js';
import axios from 'axios';
import { validatePhone, validateEmail, readSessionValue, storeSessionValue, calculateVatAmount } from './helper.js';

class Order extends Component {
  constructor() {
    super();
    this.state= {
      companyName : '',
      businessId : '',
      liters: '',
      price: '',
      combinationId: '',
      providerName: '',
      firstName: '',
      lastName: '',
      address: '',
      postcode: '',
      city: '',
      phone: '',
      email: '',
      typeUse: '',
      businessCustomer: '',
      purkuOhjeet: '',
      kirjallisetOhjeet: false,
      puhelinOhjeet: false,
      markkinointilupa: false,
      tasanTayteen: 'tasan',
    };

  }
  componentDidMount() {
    document.title = 'PÖ.fi | Omat tiedot';
    if (typeof this.props.location.state == 'undefined') {
      return (<Redirect to ="/" />);
    } else {
      if (readSessionValue('firstName') === null) {
        this.setState(this.props.location.state,function() {});
      } else {

        this.setState({liters: this.props.location.state.liters,
          providerName: this.props.location.state.providerName,
          postcode: this.props.location.state.postcode,
          combinationId: this.props.location.state.combinationId,
          typeUse: this.props.location.state.typeUse,
          businessCustomer: this.props.location.state.businessCustomer,
          tasanTayteen: this.props.location.state.tasanTayteen || 'tasan',
          puhelinOhjeet: stringToBool(readSessionValue('puhelinOhjeet')) || this.props.location.state.puhelinOhjeet || false,
          purkuOhjeet: readSessionValue('purkuOhjeet') || this.props.location.state.purkuOhjeet || '',
          kirjallisetOhjeet: stringToBool(readSessionValue('kirjallisetOhjeet')) || this.props.location.state.kirjallisetOhjeet || false,
          markkinointilupa: stringToBool(readSessionValue('markkinointilupa')) || this.props.location.state.markkinointilupa || false,
          price: this.props.location.state.price,
          firstName: readSessionValue('firstName') || '',
          lastName: readSessionValue('lastName') || '',
          address: readSessionValue('address') || '',
          city: readSessionValue('city') || '',
          phone: readSessionValue('phone') || '',
          email: readSessionValue('email') || '',
          companyName : readSessionValue('companyName') || '',
          businessId : readSessionValue('businessId') || '',
        })
      }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event' : 'checkout',
      'ecommerce' : {
        'checkout' : {
          'actionField' : {'step' : 1},
          'products' : [
            {
              'name' : this.props.location.state.providerName,
              'id' : this.props.location.state.combinationId,
              'price' : this.props.location.state.price,
              'brand' : getBrandFromProvider(this.props.location.state.providerName),
              'quantity' : this.props.location.state.liters,
            }
          ]
        }
      }
    });
  }



  changeInput = (e) => {

    if (e.target.name==="phone") {
      // Don't allow spaces in phone to avoid confusion
        if (e.target.value.indexOf(' ') === -1) {
          this.setState({[e.target.name]: e.target.value});
          storeSessionValue(e.target.name, e.target.value);
        }
    } else {
      this.setState({[e.target.name]: e.target.value});
      storeSessionValue(e.target.name, e.target.value);
    }

    let errorName = e.target.name + 'Error'
    if (this.state[errorName] === 'error') {
    if (e.target.value.length === 0) {
      this.setState({[e.target.name + 'Error']:'error'})
    } else {
      if (e.target.name === 'phone') {
        if (!validatePhone(e.target.value)) {
          this.setState({[e.target.name + 'Error']:'error'})
        } else {
          this.setState({[e.target.name + 'Error']:''})
        }
      } else if (e.target.name === 'email') {
        if (!validateEmail(e.target.value)) {
          this.setState({[e.target.name + 'Error']:'error'})
        } else {
          this.setState({[e.target.name + 'Error']:''})
        }
      }else if (e.target.name === 'businessId'){
        if (!validateBusinessId(e.target.value)) {
          this.setState({[e.target.name + 'Error']:'error'})
        } else {
          this.setState({[e.target.name + 'Error']:''})
        }
      } else {

        this.setState({[e.target.name + 'Error']:''})
      }

    }
  }

  }


  validateForm = (e) => {
    e.preventDefault();
    if (this.state.firstName.length <= 0) {
      this.setState({firstNameError: 'error'});
      window.scrollTo(0, 0);
    }
    if (this.state.lastName.length<=0) {
      this.setState({lastNameError: 'error'});
      window.scrollTo(0, 0);
    }
    if (this.state.address.length <= 0) {
      this.setState({addressError: 'error'});
      window.scrollTo(0, 0);
    }
    if (this.state.city.length <= 0) {
      this.setState({cityError: 'error'});
      window.scrollTo(0, 0);
    }
    if (!validatePhone(this.state.phone)) {
      this.setState({phoneError: 'error'});
      window.scrollTo(0, 0);
    } if (!validateEmail(this.state.email)) {
      this.setState({emailError: 'error'});
      window.scrollTo(0, 0);
    } if (this.state.businessCustomer) {
      if (this.state.companyName.length <= 0) {
        this.setState({companyNameError : 'error'});
        window.scrollTo(0, 0);
      }
      if (this.state.businessId.length <= 0) {

        this.setState({businessIdError : 'error'});
        window.scrollTo(0, 0);
      }
      if (!validateBusinessId(this.state.businessId)) {
        this.setState({businessIdError : 'error'});
        window.scrollTo(0, 0);
      }
    }
  }

  formValid = (state) => {
    if (state.firstName.length > 0 &&
      state.lastName.length>0 && state.address.length > 0 &&
      state.city.length > 0 && validatePhone(state.phone) &&
      validateEmail(state.email)) {
        if (this.state.businessCustomer) {
          if (this.state.companyName.length > 0 && validateBusinessId(this.state.businessId)) {
            return true;
          } else {
            return false;
          }
    } else {
      return true;
    }
  } else {

  return false;
}
}

  validateFieldOnBlur = (e) => {

    if (e.target.value.length === 0) {
      this.setState({[e.target.name + 'Error']:'error'})
    } else {
      if (e.target.name === 'phone') {
        if (!validatePhone(e.target.value)) {
          this.setState({[e.target.name + 'Error']:'error'})
        } else {
          this.setState({[e.target.name + 'Error']:''})
        }
      } else if (e.target.name === 'email') {
        if (!validateEmail(e.target.value)) {
          this.setState({[e.target.name + 'Error']:'error'})
        } else {
          this.setState({[e.target.name + 'Error']:''})
        }
      } else if (e.target.name === 'businessId'){
        if (!validateBusinessId(e.target.value)) {
          this.setState({[e.target.name + 'Error']:'error'})
        } else {
          this.setState({[e.target.name + 'Error']:''})
        }
      } else {

        this.setState({[e.target.name + 'Error']:''})
      }

    }
  }

  handleRadio = (e) => {
    this.setState({[e.target.name]: e.target.value});
    storeSessionValue(e.target.name, e.target.value);
  }

  handleCheckBox = (e) => {
    this.setState({[e.target.name]: e.target.checked});
    storeSessionValue(e.target.name, e.target.checked);


  }
  handleTextarea = (e) => {
    if (e.target.value.length <= 100) {
      this.setState({[e.target.name]: e.target.value});
      storeSessionValue(e.target.name, e.target.value);
    }
  }

  render() {
    let extraFormInfo;
    if (typeof this.props.location.state == 'undefined') {
      return (<Redirect to ="/" />);
    } else {
      let submitBtn;
      if (this.formValid(this.state)) {
        submitBtn = (
        <React.Fragment>
        <div>
        <Link to={{pathname:'/confirm-order', state: this.state}}>
        <button className="order-button">Vahvista tilaus</button>
        </Link>
        </div>
        <span className="instruction-info-text">Tekemällä tilauksen hyväksyt <a target="_blank" href={`${CONSTS.DOMAIN}/${CONSTS.WP_SUB_DIRECTORY}/toimitusehdot`}>toimitusehdot</a> ja <a target="_blank" href={`${CONSTS.DOMAIN}/${CONSTS.WP_SUB_DIRECTORY}/purkuohjeet`}>öljypurkujen turvallisuusohjeet</a>.</span>
        </React.Fragment>)
      } else {
        submitBtn = (<button className="order-button" onClick={this.validateForm}>Vahvista tilaus</button>)
      }
      extraFormInfo = [(
        <React.Fragment key="kirjalliset-ohjeet">
        <div className="checkbox-container">
        <label htmlFor="kirjallisetOhjeet">
        <input type="checkbox" name="kirjallisetOhjeet" id="kirjallisetOhjeet" value="kirjallisetOhjeet" checked={this.state.kirjallisetOhjeet}
        onChange={this.handleCheckBox}/>
        Haluan antaa purkuohjeet kirjallisesti</label>
        </div>
        </React.Fragment>
        ),
        (
        <React.Fragment key="puhelin-ohjeet">
        <div className="checkbox-container">
        <label htmlFor="puhelinOhjeet">
        <input type="checkbox" name="puhelinOhjeet" id="puhelinOhjeet" value="puhelinOhjeet" checked={this.state.puhelinOhjeet}
        onChange={this.handleCheckBox}/>
        Haluan antaa purkuohjeet puhelimitse</label>
        </div>
        </React.Fragment>
      )];
      if (this.state.providerName.toLowerCase().includes('teboil') || this.state.providerName.toLowerCase().includes('st1')) {
        extraFormInfo.unshift(
          <React.Fragment key="teboil-extra">
            <span>Haluatko tasan tilatun määrän, vai laitetaanko säiliö täyteen jos autossa on ylimääräistä?</span>
            <div className="radio-container">
            <div className="radio-inner-container">
            <input type="radio" id="tasan" name="tasanTayteen" value="tasan" checked={this.state.tasanTayteen === 'tasan'}
            onChange={this.handleRadio}/>
            <label htmlFor="tasan">Tasan</label>
            </div>
            <div className="radio-inner-container">
            <input type="radio" id="tayteen" name="tasanTayteen" value="tayteen" checked={this.state.tasanTayteen === 'tayteen'}
            onChange={this.handleRadio}/>
            <label htmlFor="tayteen">Täyteen (vain lasku ja erämaksu)</label>
            </div>
            </div>
          </React.Fragment>
        );
      } else {
        extraFormInfo.unshift(
          <React.Fragment key="neste-extra">
            <span>Haluatko tasan tilatun määrän, vai laitetaanko säiliö täyteen jos autossa on ylimääräistä? Huom. Nesteellä ei täyteentäyttöä.</span>
            <div className="radio-container">
              <input type="radio" id="tasan" name="tasanTayteen" value="tasan" checked={this.state.tasanTayteen === 'tasan'}
              onChange={this.handleRadio} disabled/>
              <label htmlFor="tasan">Tasan</label>
              <input type="radio" id="tayteen" name="tasanTayteen" value="tayteen" checked={this.state.tasanTayteen === 'tayteen'}
              onChange={this.handleRadio} disabled/>
              <label htmlFor="tayteen">Täyteen</label>
            </div>
          </React.Fragment>
        );
      }
      if (this.state.kirjallisetOhjeet) {
        let ohjeetSpliceAmount = 2;
        // this.state.providerName.toLowerCase().includes('teboil') ? ohjeetSpliceAmount = 2 : ohjeetSpliceAmount = 1;
        extraFormInfo.splice(ohjeetSpliceAmount, 0, (
          <React.Fragment key="kirjalliset-ohjeet-text">
            <textarea name="purkuOhjeet" placeholder="Ohjeita öljyn kuljettajalle (max 100 merkkiä)." onChange={this.handleTextarea} value={this.state.purkuOhjeet}/>
            <p className="instruction-info-text">
            <span>{this.state.purkuOhjeet.length + '/100'} </span> <br />
            Purkuohje tieto välittyy ainoastaan kuljettajalle. Emme sitoudu noudattamaan tilaukseen
            ja/tai toimitukseen liittyviä erityistoiveita, mutta pyrimme mahdollisimman hyvään palveluun mahdollisuuksien rajoissa.
            Huomioi, että St1 ja Neste purkavat vain normaalilla täyttöpaineella. Jos haluat purun pienellä paineella, valitse toimittajaksi
            Teboil. <span className="red-color">Älä laita toivetta pienestä paineesta jos toimittaja ei ole Teboil, se hidastaa toimitusta. </span><a target="_blank" href={`${CONSTS.DOMAIN}/${CONSTS.WP_SUB_DIRECTORY}/purkuohjeet`}>Lue ohjeet purkupaikan turvallisuudesta.</a>
            </p>

          </React.Fragment>
        ))
      }

      if (this.state.puhelinOhjeet) {
        extraFormInfo.push((
          <React.Fragment>
            <p className="instruction-info-text">
              Laita merkintä tähän jos ehdottomasti haluat kuljettajan soittavan ohjeet ennen täyttöä.
              Jos soitto ei ole välttämätöntä, niin älä laita merkintää. Jos tässä on merkintä eikä kuljettaja saa sinua kiinni,
              niin hän voi jättää täytön tekemättä.
            </p>
          </React.Fragment>
        ))
      }

      extraFormInfo.push((
        <React.Fragment>
          <div className="checkbox-container">
          <label htmlFor="markkinointilupa">
          <input type="checkbox" name="markkinointilupa" id="markkinointilupa" value="markkinointilupa" checked={this.state.markkinointilupa}
          onChange={this.handleCheckBox}/>
          Haluan tiedotteita ja tarjouksia sähköpostiini</label>
          </div>
        </React.Fragment>
      ));
      let errorMessage = (
        <span className="form-error-message">Kenttä täytetty virheellisesti</span>
      )
      let companyNameInput;
      if (this.state.businessCustomer) {
        companyNameInput = (
          <React.Fragment>
          <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                  <label htmlFor="companyName">Yrityksen nimi *</label>
                  <input onChange={this.changeInput} className={this.state.companyNameError} value={this.state.companyName} onBlur={this.validateFieldOnBlur} type="text" name="companyName" required></input>
                  {this.state.companyNameError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
              </div>

          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
                <label htmlFor="businessId">Y-tunnus *</label>
                <input onChange={this.changeInput} className={this.state.businessIdError} value={this.state.businessId} onBlur={this.validateFieldOnBlur} type="text" name="businessId" required></input>
                {this.state.businessIdError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
            </div>
          </div>
          </React.Fragment>
        )
      } else {
        companyNameInput = (
          <React.Fragment>
          </React.Fragment>
        )
      }
      return (
<div className="body-container order-page">
    <div className="sub-nav">
        <SubNav currPage="order"/>
    </div>

    <div className="order-container">
      <form>
        <h3>Toimitustiedot</h3>
        <div className="row">
            <div className="order-form col-sm-12 col-md-6 col-lg-6">

                    {companyNameInput}
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="firstName">Etunimi *</label>
                            <input onChange={this.changeInput} className={this.state.firstNameError} value={this.state.firstName} onBlur={this.validateFieldOnBlur} type="text" name="firstName" required></input>
                            {this.state.firstNameError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="lastName">Sukunimi *</label>
                            <input onChange={this.changeInput} className={this.state.lastNameError} value={this.state.lastName} onBlur={this.validateFieldOnBlur} type="text" name="lastName" required></input>
                            {this.state.lastNameError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
                        </div>
                    </div>

                    <div className="row custom-input-row-address">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <label htmlFor="address">Katuosoite *</label>
                            <input onChange={this.changeInput} className={this.state.addressError} value={this.state.address} onBlur={this.validateFieldOnBlur} type="text" name="address" required></input>
                            {this.state.addressError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
                        </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 inside-input">
                        <span className="instruction-info-text">Kirjoita osoitetiedot, johon öljy toimitetaan.</span>
                      </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <p>Postinumero *</p>
                            <p>{this.state.postcode}</p>

                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="city">Postitoimipaikka *</label>
                            <input onChange={this.changeInput} className={this.state.cityError} value={this.state.city} onBlur={this.validateFieldOnBlur} type='text' name="city" required></input>
                            {this.state.cityError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="phone">Puhelinumero *</label>
                            <input onChange={this.changeInput} className={this.state.phoneError} value={this.state.phone} onBlur={this.validateFieldOnBlur} type='text' name="phone" required></input>
                            {this.state.phoneError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6">
                            <label htmlFor="email">Sähköpostiosoite *</label>
                            <input onChange={this.changeInput} className={this.state.emailError} value={this.state.email} onBlur={this.validateFieldOnBlur} type='text' name="email" required></input>
                            {this.state.emailError === 'error' ? <React.Fragment>{errorMessage}</React.Fragment> : <React.Fragment><span></span></React.Fragment>}
                        </div>
                    </div>

                    <input type="hidden" name="combination-id" value={this.state.combinationId}></input>
                    <input type="hidden" name="postcode" value={this.state.postcode}></input>

            </div>
            <div className="order-information col-sm-12 col-md-6 col-lg-6">
                <div className="order-info-wrap">
                    <OrderInformation providerName={this.state.providerName} postcode={this.state.postcode} amount={this.state.liters}
                    price={((this.state.price)*this.state.liters).toFixed(2)} city={this.state.city}
                    noVatPrice={calculateVatAmount((this.state.price)*this.state.liters, 24)[0].toFixed(2)}
                    vatAmount={calculateVatAmount((this.state.price)*this.state.liters, 24)[1].toFixed(2)}
                    typeUse={this.state.typeUse === 'lammityskaytto' ? 'Lämmityskäyttöön' : 'Moottorikäyttöön'}
                    linkTo={{pathname: '/'}} linkText='Muuta tilausta'/>
                </div>
            </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 extra-form">
                    <h3>Lisätiedot</h3>
                    {extraFormInfo}
                    {submitBtn}
                </div>
            </div>

        </form>
    </div>

</div>
      )
    }

  }
}

export default Order;
